"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentPreview = void 0;
const react_1 = __importDefault(require("react"));
function DocumentPreview() {
    return (react_1.default.createElement(react_1.default.Fragment, null));
}
exports.DocumentPreview = DocumentPreview;
